import React from 'react';
import blogData from '../blog/articles';

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function formatArticleDate(iso) {
  const [year, month, day] = String(iso).split('-').map(Number);
  if (!year || !month || !day) return iso;
  return `${MONTHS[month - 1]} ${day}, ${year}`;
}

export default function BlogByline({ datePublished, compact = false }) {
  const { author } = blogData;
  const dateLabel = formatArticleDate(datePublished);

  return (
    <p className={compact ? 'blog-byline blog-byline-compact' : 'blog-byline'}>
      <span className="blog-byline-writer">
        By {author.name}, {author.jobTitle}
      </span>
      {compact ? ' · ' : ' '}
      <time dateTime={datePublished}>{dateLabel}</time>
    </p>
  );
}
